(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-mobile"]) return;
  try {
    

document.addEventListener('DOMContentLoaded', function(){
  let homeMenu = document.getElementById("mobile-home-menu")
  let shopMenu = document.getElementById("mobile-shop-menu")
  let learnMenu = document.getElementById("mobile-learn-menu")
  let aboutMenu = document.getElementById("mobile-about-menu")
  let customizeMenu = document.getElementById("mobile-customize-menu")
  let accountMenu = document.getElementById("mobile-account-menu")
  let backButtons = document.getElementsByClassName("back-home")
  let shopButtons = document.getElementsByClassName("shop-button")
  let acc = document.getElementsByClassName("accordion");
  let hamburger = document.getElementById("hamburger")
  let mobileFooter = document.getElementById("mobile-footer")
  let closeMenu = document.getElementById("close-menu")
  let mainContent = document.getElementById("MainContent")

  // Function to open the first accordion panel with a bold dash
  function openFirstAccordion() {
    if (acc.length > 0) {
      acc[0].classList.add("active");
      const panel = acc[0].nextElementSibling;
      acc[0].style.marginBottom = '20px';

      // Create a bold dash element if it doesn't already exist
      if (!acc[0].querySelector('strong')) {
        const boldDash = document.createElement('strong');
        boldDash.textContent = '—';
        acc[0].appendChild(boldDash);
      }

      panel.style.paddingBottom = '30px';
      panel.style.maxHeight = panel.scrollHeight + 32 + "px";
      panel.style.borderBottomWidth = '1px';
    }
  }

  // Function to clear all bold dashes from accordion elements
  function clearBoldDashes() {
    for (let i = 0; i < acc.length; i++) {
      const boldDash = acc[i].querySelector('strong');
      if (boldDash && boldDash.textContent === '—') {
        acc[i].removeChild(boldDash);
      }
      acc[i].classList.remove("active"); // Reset accordion state
      acc[i].style.marginBottom = '0px'; // Reset margin
      const panel = acc[i].nextElementSibling;
      panel.style.paddingBottom = '0px';
      panel.style.maxHeight = null;
      panel.style.borderBottomWidth = '0px';
    }
  }

  hamburger?.addEventListener("click", function() {
    homeMenu.classList.remove("!hidden")
    closeMenu.classList.remove("!hidden")
    hamburger.classList.add("!hidden")
    mainContent.classList.add("!hidden")
    mobileFooter.classList.add("!hidden")
  })

  closeMenu?.addEventListener("click", function() {
    mainContent.classList.remove("!hidden")
    mobileFooter.classList.remove("!hidden")
    homeMenu.classList.add("!hidden")
    shopMenu.classList.add("!hidden")
    learnMenu.classList.add("!hidden")
    aboutMenu.classList.add("!hidden")
    customizeMenu.classList.add("!hidden")
    accountMenu.classList.add("!hidden")
    closeMenu.classList.add("!hidden")
    hamburger.classList.remove("!hidden")
    clearBoldDashes(); // Clear any bold dashes on close
  })

  for (let num = 0; num < backButtons.length; num++) {
    backButtons[num].addEventListener("click", function() {
      homeMenu.classList.remove("!hidden")
      shopMenu.classList.add("!hidden")
      learnMenu.classList.add("!hidden")
      aboutMenu.classList.add("!hidden")
      customizeMenu.classList.add("!hidden")
      accountMenu.classList.add("!hidden")
      clearBoldDashes(); // Clear any bold dashes on navigating back to home
    });
  }

  for (let num = 0; num < shopButtons.length; num++) {
    shopButtons[num].addEventListener("click", function() {
      document.getElementById(`mobile-${shopButtons[num].getAttribute('data-link')}`).classList.remove("!hidden")
      homeMenu.classList.add("!hidden")
      openFirstAccordion(); // Open the first accordion when a menu is clicked
    });
  }

  for (let i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      for (let count = 0; count < acc.length; count++) {
        if (count == i) {
          acc[count].classList.add("active");
        } else {
          acc[count].classList.remove("active");
        }

        if (acc[count].classList.contains("active")) {
          let panel = acc[count].nextElementSibling;
          if (panel.style.maxHeight) {
            acc[count].style.marginBottom = '0px';

            // Remove the bold dash if it exists
            const lastChild = acc[count].lastChild;
            if (lastChild && lastChild.tagName === 'STRONG' && lastChild.textContent === '—') {
              acc[count].removeChild(lastChild);
            }

            panel.style.paddingBottom = '0px';
            panel.style.maxHeight = null;
            panel.style.borderBottomWidth = '0px';
            acc[count].classList.remove("active");
          } else {
            acc[count].style.marginBottom = '20px';

            // Add the bold dash if it doesn't exist
            if (!acc[count].querySelector('strong')) {
              const boldDash = document.createElement('strong');
              boldDash.textContent = '—';
              acc[count].appendChild(boldDash);
            }

            panel.style.paddingBottom = '30px';
            panel.style.maxHeight = panel.scrollHeight + 32 + "px";
            panel.style.borderBottomWidth = '1px';
          }
        } else {
          let panel = acc[count].nextElementSibling;
          acc[count].style.marginBottom = '0px';

          // Ensure any bold dash is removed
          const lastChild = acc[count].lastChild;
          if (lastChild && lastChild.tagName === 'STRONG' && lastChild.textContent === '—') {
            acc[count].removeChild(lastChild);
          }

          panel.style.paddingBottom = '0px';
          panel.style.maxHeight = null;
          panel.style.borderBottomWidth = '0px';
        }
      }
    });
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let col1 = document.getElementById('col-1');
    let column1 = document.getElementById('column-1');
    column1.innerHTML = col1.innerHTML;
    let col2 = document.getElementById('col-2');
    let column2 = document.getElementById('column-2');
    column2.innerHTML = col2.innerHTML;
    let col3 = document.getElementById('col-3');
    let column3 = document.getElementById('column-3');
    column3.innerHTML = col3.innerHTML;
    let col4 = document.getElementById('col-4');
    let column4 = document.getElementById('column-4');
    column4.innerHTML = col4.innerHTML;
    let col5 = document.getElementById('col-5');
    let column5 = document.getElementById('column-5');
    column5.innerHTML = col5.innerHTML;
    let col6 = document.getElementById('col-6');
    let column6 = document.getElementById('column-6');
    column6.innerHTML = col6.innerHTML;

    let learncol1 = document.getElementById('learncol-1');
    let learncolumn1 = document.getElementById('learncolumn-1');
    learncolumn1.innerHTML = learncol1.innerHTML;
    let learncol2 = document.getElementById('learncol-2');
    let learncolumn2 = document.getElementById('learncolumn-2');
    learncolumn2.innerHTML = learncol2.innerHTML;
    let learncol3 = document.getElementById('learncol-3');
    let learncolumn3 = document.getElementById('learncolumn-3');
    learncolumn3.innerHTML = learncol3.innerHTML;

    let aboutcol1 = document.getElementById('aboutcol-1');
    let aboutcolumn1 = document.getElementById('aboutcolumn-1');
    aboutcolumn1.innerHTML = aboutcol1.innerHTML;
    let aboutcol2 = document.getElementById('aboutcol-2');
    let aboutcolumn2 = document.getElementById('aboutcolumn-2');
    aboutcolumn2.innerHTML = aboutcol2.innerHTML;
    let aboutcol3 = document.getElementById('aboutcol-3');
    let aboutcolumn3 = document.getElementById('aboutcolumn-3');
    aboutcolumn3.innerHTML = aboutcol3.innerHTML;
    let aboutcol4 = document.getElementById('aboutcol-4');
    let aboutcolumn4 = document.getElementById('aboutcolumn-4');
    aboutcolumn4.innerHTML = aboutcol4.innerHTML;
  });

  let megaDropDown = document.getElementById('mega-drop-down');
  let learnDropDown = document.getElementById('learn-drop-down');
  let aboutDropDown = document.getElementById('about-drop-down');
  let announcementBar = document.getElementById('shopify-section-announcement-bar');

  document.querySelectorAll('.non-drop-down').forEach(function (dropdown) {
    dropdown.addEventListener('mouseover', function () {
      // Toggle the display of the dropdown menu
      megaDropDown.classList.add('!hidden');
      learnDropDown.classList.add('!hidden');
      aboutDropDown.classList.add('!hidden');
    });
  });
  document.getElementById('first-drop')?.addEventListener('mouseover', function () {
    // Toggle the display of the dropdown menu
    megaDropDown.classList.remove('!hidden');
  });
  document.getElementById('second-drop')?.addEventListener('mouseover', function () {
    // Toggle the display of the dropdown menu
    learnDropDown.classList.remove('!hidden');
  });

  document.getElementById('right-first-drop')?.addEventListener('mouseover', function () {
    // Toggle the display of the dropdown menu
    aboutDropDown.classList.remove('!hidden');
  });

  announcementBar?.addEventListener('mouseover', function () {
    megaDropDown?.classList.add('!hidden');
    learnDropDown?.classList.add('!hidden');
    aboutDropDown?.classList.add('!hidden');
  });
  megaDropDown?.addEventListener('mouseover', function () {
    megaDropDown?.classList.remove('!hidden');
  });
  megaDropDown?.addEventListener('mouseout', function () {
    megaDropDown?.classList.add('!hidden');
  });
  learnDropDown?.addEventListener('mouseover', function () {
    learnDropDown?.classList.remove('!hidden');
  });
  learnDropDown?.addEventListener('mouseout', function () {
    learnDropDown?.classList.add('!hidden');
  });
  aboutDropDown?.addEventListener('mouseover', function () {
    aboutDropDown?.classList.remove('!hidden');
  });
  aboutDropDown?.addEventListener('mouseout', function () {
    aboutDropDown?.classList.add('!hidden');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
        let relatedCartButtons = document.getElementsByClassName('related-cart');
        for (let i = 0; i < relatedCartButtons.length; i++) {
          relatedCartButtons[i].addEventListener("click", function() {
            if (relatedCartButtons[i].dataset.inventory > 0) {
              addToCart(parseInt(relatedCartButtons[i].dataset.id), 1)
            }
          })
        }

        let parentForButtons = document.getElementsByClassName('parent-for-buttons');
        // Check if screen width is mobile/tablet size (1023px or less)
        if (window.matchMedia("(max-width: 1023px)").matches) {
          for (let i = 0; i < parentForButtons.length; i++) {
            parentForButtons[i].addEventListener("click", function() {
              window.location.href = parentForButtons[i].dataset.url;
            });
          }
        }

      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
